import { ApiClientError } from '@tkpod/api-client';

const FIELD_CODES = new Set([
  'OPTIONS_INVALID_CONFIG',
  'OPTIONS_KEY_TAKEN',
  'OPTIONS_NOT_ELIGIBLE',
  'OPTIONS_DESIGNER_MODE_LOCKED',
  'OPTIONS_BLOCK_DISABLED',
]);

export interface OptionActionFailure {
  message: string;
  fieldErrors: { field: string; message: string }[];
}

/** Prefer the API sentence for a known option code. Fall back to the toast text. */
export function optionActionMessage(err: unknown, fallback: string): string {
  return optionActionFailure(err, fallback).message;
}

/** Message plus the API field list, so the editor can highlight the tab that failed. */
export function optionActionFailure(err: unknown, fallback: string): OptionActionFailure {
  if (err instanceof ApiClientError) {
    const fieldErrors = (err.apiError?.details ?? [])
      .filter((detail) => detail.field && detail.message)
      .map((detail) => ({ field: detail.field, message: detail.message }));
    if (err.errorCode === 'OPTIONS_BLOCK_DISABLED') {
      return { message: 'Product options are turned off for the platform.', fieldErrors };
    }
    const message = (FIELD_CODES.has(err.errorCode) && err.message.trim()) || err.message.trim() || fallback;
    return { message, fieldErrors };
  }
  if (err instanceof Error && err.message.trim()) return { message: err.message, fieldErrors: [] };
  return { message: fallback, fieldErrors: [] };
}
